module.exports = __webpack_public_path__ + "static/media/timelapse_32.7ec65a9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/timelapse_32.jpg
// module id = 990
// module chunks = 0